import { useEffect } from 'react';
import { AuthenticationFactory } from '../services/Auth/AuthenticationFactory';

const LogoutPage = () => {
  useEffect(() => {
    const doLogout = async () => {
      console.debug("[LogoutPage] Logging out...");

      const authType = import.meta.env.VITE_AUTH_PROVIDER?.replace(/['"]+/g, '') || 'siteminder';
      console.log("[LogoutPage] VITE_AUTH_PROVIDER from env:", import.meta.env.VITE_AUTH_PROVIDER);
      sessionStorage.removeItem("loginDenied");

      const authService = AuthenticationFactory.getAuthService(authType);

      try {
        await authService.logout();
      } catch (err) {
        console.error("[LogoutPage] Error during logout", err);
      }
    };

    doLogout();
  }, []);

  return <div>Logging you out...</div>;
};

export default LogoutPage;
